import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { theme } from "../components/theme";
import logo from "../assets/logo.png";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError("Email ose fjalëkalimi është i gabuar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page>
      <Card>
        <Logo src={logo} alt="OrgaLife" />
        <Title>Admin Panel</Title>
        <Sub>Hyni për të menaxhuar produktet</Sub>
        <Form onSubmit={handleSubmit}>
          <Input type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} required />
          <Input type="password" placeholder="Fjalëkalimi" value={password}
            onChange={(e) => setPassword(e.target.value)} required />
          {error && <ErrorMsg>{error}</ErrorMsg>}
          <LoginBtn type="submit" disabled={loading}>
            {loading ? "Duke hyrë..." : "Hyr →"}
          </LoginBtn>
        </Form>
      </Card>
    </Page>
  );
}

const Page = styled.div`
  min-height: 100vh; background: ${theme.colors.bg};
  display: flex; align-items: center; justify-content: center; padding: 2rem;
`;
const Card = styled.div`
  background: ${theme.colors.bgCard}; border: 1px solid ${theme.colors.borderSubtle};
  border-radius: ${theme.radius.lg}; padding: 3rem 2.5rem; width: 100%; max-width: 420px;
  text-align: center;
`;
const Logo = styled.img`height: 48px; margin-bottom: 1.5rem; filter: brightness(0.85);`;
const Title = styled.h1`
  font-family: 'Playfair Display', serif; font-size: 1.8rem; font-style: italic;
  color: ${theme.colors.textPrimary}; margin: 0 0 0.4rem;
`;
const Sub = styled.p`font-size: 0.85rem; color: ${theme.colors.textMuted}; margin-bottom: 2rem;`;
const Form = styled.form`display: flex; flex-direction: column; gap: 1rem;`;
const Input = styled.input`
  background: ${theme.colors.bgSurface}; border: 1px solid ${theme.colors.borderSubtle};
  border-radius: ${theme.radius.md}; padding: 0.85rem 1rem;
  color: ${theme.colors.textPrimary}; font-size: 0.9rem; font-family: inherit;
  outline: none; width: 100%; box-sizing: border-box;
  &:focus { border-color: #89d146; }
  &::placeholder { color: ${theme.colors.textMuted}; }
`;
const ErrorMsg = styled.p`color: #e05c5c; font-size: 0.82rem; margin: 0;`;
const LoginBtn = styled.button`
  padding: 0.95rem; border-radius: 999px; border: none;
  background: #89d146; color: white; font-size: 0.95rem; font-weight: 600;
  font-family: inherit; cursor: pointer; transition: all 0.25s ease;
  &:hover:not(:disabled) { background: #7bc23e; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;
